import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
// 8443 메인 앱과 동일한 디자인 토큰 시스템(reset + tokens). data-theme/mode 는 index.html 에 설정.
import './styles/reset.css';
import './styles/tokens.css';
import { App } from './App';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
